export function CanExecute() {
    return (_: any, name: string | symbol, descriptor: PropertyDescriptor) => {
        const original = descriptor.value;

        descriptor.value = function (this: any, ...args: any[]) {
            if (this.canExecute.result.some((r: any) => r.action === descriptor.value && !r.canExecute))
                throw new Error(`Method '${this.constructor.name}.${String(name)}' cannot be executed.`);
            return original.apply(this, args);
        };

        return descriptor;
    };
}
